
import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)

//hci
const Hci  = () => import(/* webpackChunkName: "Hci" */ '@/components/onboarding/hci/Hci.vue');
const HCIPaymentConfirmation  = () => import(/* webpackChunkName: "HCIPaymentConfirmation" */ '@/components/onboarding/hci/PaymentConfirmation.vue');
const HCIGroup = () => import(/* webpackChunkName: "HCIGroup" */ '@/components/onboarding/hci/group/Group.vue');
const HCIFamily = () => import(/* webpackChunkName: "HCIFamily" */ '@/components/onboarding/hci/family/Family.vue');
const HciGroupPaymentConfirmation = () => import(/* webpackChunkName: "HciGroupPaymentConfirmation" */ '@/components/onboarding/hci/GroupPaymentConfirmation.vue');
const HciFamilyPaymentConfirmation = () => import(/* webpackChunkName: "HciFamilyPaymentConfirmation" */ '@/components/onboarding/hci/FamilyPaymentConfirmation.vue');





//tokenization
const Retokenize = () => import (/*webpackChunkName: "Retokenize" */ '@/components/onboarding/retokenize.vue');
const RetokenizeConfirmation = () => import (/*webpackChunkName: "Retokenize" */ '@/components/onboarding/retokenize-confirmation.vue');


let router = new Router({
  // base:process.env=='development'? '/' : '/platform',
  // base:'/platform',
  mode: 'history',
  routes: [
    {path:'/', name:'Hci', component:Hci},
    {path:'/payment-confirmation/:txnRef', name:'HCIPaymentConfirmation', component:HCIPaymentConfirmation,props:true},
    {path: '/group', name: 'HCIGroup', component: HCIGroup},
    {path: '/family', name: 'HCIFamily', component: HCIFamily},
    {path: '/group/payment-confirmation/:txnRef?', name:'HciGroupPaymentConfirmation',component: HciGroupPaymentConfirmation, props:true},
    {path: '/family/payment-confirmation/:txnRef?', name:'HciFamilyPaymentConfirmation',component: HciFamilyPaymentConfirmation, props:true},
    // {path: '/retokenize', name:'Retokenize', component:Retokenize},
    // {path: '/retokenize-confirmation/:txnRef?', name:'RetokenizeConfirmation', component:RetokenizeConfirmation, props:true},

  ]
})

// import store from '@/vuex_store/store.js'
// router.beforeEach((to, from, next) => {
//   if(to.matched.some(record => record.meta.requiresAuth)) {
//     if (store.getters.isLoggedIn) {
//       next()
//       return
//     }
//     next('/corporate/login') 
//   } else {
//     next() 
//   }
// })

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js